export const fadeIn = {
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
}



// WEBPACK FOOTER //
// ./src/utils/animations.ts